import React from 'react';
import {useSearchParams} from 'react-router-dom';
import {HelmetProvider} from 'react-helmet-async';
/* import {LocalizationProvider} from 'packages/common/locales'; */
import {SnackbarProvider} from 'packages/common/components/snackbar';
import {SettingsProvider} from 'packages/common/components/settings';
import ThemeProvider from 'packages/common/theme';

export default function WidgetPage({children}) {
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const apiKey = searchParams.get('apiKey');

  const settings = {
    themeMode: 'light',
    themeDirection: 'ltr',
    themeContrast: 'default',
    themeLayout: 'vertical',
    themeColorPresets: 'default',
  };

  return (
    <HelmetProvider>
      {/* <LocalizationProvider> */}
      <SettingsProvider defaultSettings={settings}>
        <ThemeProvider>
          <SnackbarProvider>
            {React.cloneElement(children, {
              companyId: companyId || '',
              apiKey: apiKey || '',
            })}
          </SnackbarProvider>
        </ThemeProvider>
      </SettingsProvider>
      {/* </LocalizationProvider> */}
    </HelmetProvider>
  );
}
